/* eslint-disable consistent-return */
// @ts-check
import $ from "jquery";
import {isEmail} from '../utils.js';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { trackLogin } from "../tracking.js";

// https://github.com/fingerprintjs/fingerprintjs
async function generateFingerprint() {
    if ($('body').hasClass('login')) {
        const fpPromise = FingerprintJS.load({monitoring: false})
        
        const fp = await fpPromise
        const result = await fp.get()
        // this would be the default way how to retrive fingerprint hash, based on all default components
        // const visitorId = result.visitorId
        
        const { touchSupport, colorDepth, platform} = result.components;
        
        // more info in EVR-8955
        // we only like to send to backend system relevant info, not browser specific one
        const customComponents = {
            colorDepth,
            platform,
            touchSupport
        }
    
        const fingerprintId = FingerprintJS.hashComponents(customComponents);
        $('input[name="fingerprint_id"]').val(fingerprintId);
    }
}

function enableLoginButton() {
	$('#login-btn').prop( "disabled", false );
	$('#login-btn').css( "cursor", 'pointer' );
	window.removeEventListener('RECAPTCHA_TOKEN_GENERATED', enableLoginButton, true)
}

$(document).on('ready', () => {
	if ($('body').hasClass('login')) {
        // when page is loaded, make sure user cannot click login button before recaptcha is generated
		$('#login-btn').prop( "disabled", true );
		$('#login-btn').css( "cursor", 'default' );
		window.addEventListener('RECAPTCHA_TOKEN_GENERATED', enableLoginButton);
	}
});

export async function handleLogin() {
    /* LOGIN */

    try {
        await generateFingerprint();
    } catch (err) {
        console.log('error, could not generate fingerprint: ', err);
    } finally {
        $('body').on('submit', 'form[name="login"]', function (e) {
            'use strict'
            e.preventDefault()
    
            const button = $(this).find('button[type="submit"]')
            const emailAddress = $(this).find('[name="email_address"]').val()
            const password = $(this).find('[name="password"]').val()
            let error = false
    
            if (!emailAddress || !isEmail(emailAddress)) {
                error = true
                $(this).find('[name="email_address"]').addClass('error')
            } else {
                trackLogin();
                $(this).find('[name="email_address"]').removeClass('error')
            }
    
            if (!password) {
                error = true
                $(this).find('[name="password"]').addClass('error')
            } else {
                $(this).find('[name="password"]').removeClass('error')
            }
    
            if (error === true) {
                return false
            }
    
            button.addClass('loading')
    
            // adding [0] after "this" avoids jQuery Loop error
            $(this)[0].submit()
        })
    }
}
